import { create } from 'zustand';

interface IFuncoesNavbarStore {
    categoriaSelecionada: string | undefined;
    setCategoriaSelecionada: (categoria: string | undefined) => void;

    termoPesquisa: string;
    setTermoPesquisa: (termo: string) => void;

    titulo: string;
    setTitulo: (titulo: string) => void;
}

export const useFuncoesNavbarStore = create<IFuncoesNavbarStore>()((set) => ({
    categoriaSelecionada: undefined,
    setCategoriaSelecionada: (categoria) => set({ categoriaSelecionada: categoria }),

    termoPesquisa: '',
    setTermoPesquisa: (termo) => set({ termoPesquisa: termo }),

    titulo: '',
    setTitulo: (titulo) => set({ titulo: titulo }),
}));